export default __webpack_public_path__ + "src/images/cat-mapper-max-ogden-EcsCeS6haJ8-unsplash.jpg";